import { render, staticRenderFns } from "./colorSelector.vue?vue&type=template&id=50f8463b&scoped=true&"
import script from "./colorSelector.ts?vue&type=script&lang=ts&"
export * from "./colorSelector.ts?vue&type=script&lang=ts&"
import style0 from "./colorSelector.scss?vue&type=style&index=0&id=50f8463b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8463b",
  null
  
)

export default component.exports